module.exports = __webpack_public_path__ + "static/laseroterapia-image-3-e03a4fa6ba3debf026a5cfc758eb4732.png";